import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { EButtonType } from "../../data-types/button.enum";
import { EInputStyleType } from "../../data-types/input-style.enum";
import { ETextareaStyleType } from "../../data-types/textarea-style.enum";
import { FormArray, FormControl, Validators } from "@angular/forms";
import { FormGroup } from "@angular/forms";
import { Router } from "@angular/router";
import { EInputMediaStyleType } from "../../data-types/input-media-style.enum";
import { iconsLibrary } from "../../../theme/constants";
import { NgxCSVParserError, NgxCsvParser } from "ngx-csv-parser";
import { showAlertAction } from "../../store/actions/alert.action";
import { TranslateService } from "@ngx-translate/core";
import { Store } from "@ngrx/store";
import {
  closeLoadingAction,
  showLoadingAction,
} from "../../store/actions/loading.action";
import { UserService } from "../../services/user.service";
import { IAppState } from "../../store/state/app.state";
import { CompanyService } from "../../services/company.service";
import { LocalStorageService } from "../../services/local-storage.service";
import { EStorageType } from "../../data-types/storage.enum";

var window: any;

@Component({
  selector: "cowing-core-backoffice",
  templateUrl: "./backoffice.component.html",
  styleUrls: ["./backoffice.component.scss"],
})
export class BackofficeComponent implements OnInit {
  constructor(
    private router: Router,
    private localStorageService: LocalStorageService
  ) {}
  async ngOnInit() {}
  private activeTab = "CompaÃ±Ã­as";
  get getActiveTab() {
    return this.activeTab;
  }
  public tabChange(event) {
    this.activeTab = event.tab.textLabel;
  }
  public logOut() {
    this.localStorageService.clear();
    return this.navigateTo("login");
  }

  private navigateTo(link) {
    this.router.navigate([link]);
  }
  public get getLogoutIcon() {
    return `${iconsLibrary.logOutProfileActive}`;
  }
}
